var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6666 28.5H61.6666C63.3235 28.5 64.6666 29.8431 64.6666 31.5V61.5C64.6666 63.1569 63.3235 64.5 61.6666 64.5H45.6666C44.0098 64.5 42.6666 63.1569 42.6666 61.5V31.5C42.6666 29.8431 44.0098 28.5 45.6666 28.5ZM45.6666 30.5C45.1143 30.5 44.6666 30.9477 44.6666 31.5V61.5C44.6666 62.0523 45.1143 62.5 45.6666 62.5H61.6666C62.2189 62.5 62.6666 62.0523 62.6666 61.5V31.5C62.6666 30.9477 62.2189 30.5 61.6666 30.5H45.6666Z",
    fill: "#537FF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6666 18C18.1143 18 17.6666 18.4477 17.6666 19V61.5C17.6666 62.0523 18.1143 62.5 18.6666 62.5H38.6666C39.2189 62.5 39.6666 62.9477 39.6666 63.5C39.6666 64.0523 39.2189 64.5 38.6666 64.5H18.6666C17.0098 64.5 15.6666 63.1569 15.6666 61.5V19C15.6666 17.3431 17.0098 16 18.6666 16H49.1666C50.8235 16 52.1666 17.3431 52.1666 19V24.5C52.1666 25.0523 51.7189 25.5 51.1666 25.5C50.6143 25.5 50.1666 25.0523 50.1666 24.5V19C50.1666 18.4477 49.7189 18 49.1666 18H18.6666Z",
    fill: "#537FF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6666 59.5C54.6666 60.0523 54.2189 60.5 53.6666 60.5C53.1143 60.5 52.6666 60.0523 52.6666 59.5C52.6666 58.9477 53.1143 58.5 53.6666 58.5C54.2189 58.5 54.6666 58.9477 54.6666 59.5Z",
    fill: "#537FF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6666 59.5C34.6666 60.0523 34.2189 60.5 33.6666 60.5C33.1143 60.5 32.6666 60.0523 32.6666 59.5C32.6666 58.9477 33.1143 58.5 33.6666 58.5C34.2189 58.5 34.6666 58.9477 34.6666 59.5Z",
    fill: "#537FF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon1);
export default __webpack_public_path__ + "static/media/homeIcon1.bc70c40fc433ff995f501793283cfd2c.svg";
export { ForwardRef as ReactComponent };